module.exports = __webpack_public_path__ + "fonts/SourceHanSerifCN-Heavy-4.f983acba.otf";